// /**
//  * Warehouses - list
//  */

// React
import React, {useContext} from 'react';
import {Link} from 'react-router-dom';

// UI
import theme from '../../../theme';
import {
  createStyles,
  makeStyles,
  Theme,
  withStyles,
} from '@material-ui/core/styles';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
  Paper,
  IconButton,
  FormControlLabel,
  FormControl,
  FormLabel,
  RadioGroup,
  Radio,
  Select,
} from '@material-ui/core';

// Icon
import Icon from '@mdi/react';
import {
  mdiClose,
  mdiPencilOutline,
  mdiFileDocumentOutline,
  mdiHistory,
  mdiArrowCollapseAll,
} from '@mdi/js';

// Helper
import {formaterPhoneNumber, translate} from '../../../utils/helpers';

//Component
import jMoment from 'moment-jalaali';

// Type
import {Parcels} from '../interfaces';
import AuthContext from '../../../authContext';
import Can from '../../../components/Can';

type Data = Parcels;
type Props = {
  data: any;
  handleOpenConfirmDisable: (id: number) => void;
  handleOpen: (id: number, type: string) => void;
  changeStatus: any;
};

type Ord = 'asc' | 'desc';

interface HeadCell {
  // id: keyof Data;
  id: any;
  label: string;
}

interface EnhancedTableProps {
  classes: ReturnType<typeof useStyles>;
  onRequestSort: (
    event: React.MouseEvent<unknown>,
    property: keyof Data
  ) => void;
  order: Ord;
  orderBy: string;
  rowCount: number;
}

// Style
const StyledTableCell = withStyles((theme: Theme) =>
  createStyles({
    head: {
      backgroundColor: '#D5DADD !important',
      color: '#212121',
    },
    body: {
      fontSize: 14,
    },
  })
)(TableCell);

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
    },
    paper: {
      width: '100%',
    },
    table: {
      minWidth: 750,
    },
    head: {
      backgroundColor: '#D5DADD !important',
      color: '#212121',
    },
    visuallyHidden: {
      border: 0,
      clip: 'rect(0 0 0 0)',
      height: 1,
      margin: -1,
      overflow: 'hidden',
      padding: 0,
      position: 'absolute',
      top: 20,
      width: 1,
    },
    changStatusIcon: {
      marginRight: '10px',
      position: 'absolute',
    },
    changStatusBox: {
      display: 'flex',
      textAlign: 'left',

      fontWeight: 400,
      fontSize: '14px',
    },
    renderValue: {
      paddingLeft: '32px',
    },
    radioGroup: {
      margin: '-8px 0',
    },
    radioGroupItem: {
      borderBottom: '1px solid #D8D8D8',
      marginRight: '-8px',
      padding: '8px 16px',
      '&:last-child': {
        borderBottom: '0px',
      },
    },
  })
);

function descendingComparator<T>(a: T, b: T, orderBy: keyof T) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator<Key extends keyof any>(
  order: Ord,
  orderBy: Key
): (
  a: {[key in Key]: number | string},
  b: {[key in Key]: number | string}
) => number {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort<T>(array: T[], comparator: (a: T, b: T) => number) {
  const stabilizedThis = array.map((el, index) => [el, index] as [T, number]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map(el => el[0]);
}

const headCells: HeadCell[] = [
  {
    id: 'destinationWarehouseName',
    label: 'انبار مقصد',
  },
  {
    id: 'id',
    label: 'شناسه محموله',
  },
  {
    id: 'shippingDate',
    label: 'تاریخ ثبت',
  },
  {
    id: 'deliveryDate',
    label: 'تاریخ تحویل',
  },
  {
    id: 'deliveryTime',
    label: 'بازه تحویل',
  },
  {
    id: 'status',
    label: 'وضعیت',
  },
];

function EnhancedTableHead(props: EnhancedTableProps) {
  const {order, orderBy, onRequestSort} = props;
  const createSortHandler =
    (property: keyof Data) => (event: React.MouseEvent<unknown>) => {
      onRequestSort(event, property);
    };

  return (
    <TableHead>
      <TableRow>
        {headCells.map(headCell => (
          <StyledTableCell
            key={headCell.id}
            align="center"
            sortDirection={orderBy === headCell.id ? order : false}
            data-cy={headCell.id}
          >
            <TableSortLabel
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
            </TableSortLabel>
          </StyledTableCell>
        ))}
        <StyledTableCell />
      </TableRow>
    </TableHead>
  );
}

export default function EnhancedTable(props: Props) {
  const authContext = useContext(AuthContext);
  const classes = useStyles();
  const [order, setOrder] = React.useState<Ord>('desc');
  // const [orderBy, setOrderBy] = React.useState<keyof Data>('id');
  const [orderBy, setOrderBy] = React.useState<any>('id');
  const [dense] = React.useState(false);
  const {handleOpenConfirmDisable, handleOpen} = props;

  const handleRequestSort = (
    event: React.MouseEvent<unknown>,
    property: keyof Data
  ) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  return (
    <div className={classes.root}>
      <TableContainer>
        <Table
          className={classes.table}
          aria-labelledby="tableTitle"
          size={dense ? 'small' : 'medium'}
          aria-label="enhanced table"
        >
          <EnhancedTableHead
            classes={classes}
            order={order}
            orderBy={orderBy}
            onRequestSort={handleRequestSort}
            rowCount={props.data.length}
          />
          <TableBody>
            {stableSort(props.data, getComparator(order, orderBy))
              .slice()
              .map((row: any, index: number) => {
                const labelId = `enhanced-table-checkbox-${index}`;

                let color = '';
                let backgroundColor = '';

                switch (true) {
                  case row.status === 'LOCATED':
                    backgroundColor = '#b1f6ac';
                    color = '#1c581a';
                    break;
                  case row.status === 'CANCELLED' ||
                    row.status === 'CONFLICTED':
                    backgroundColor = '#fdd1cc';
                    color = '#611a15';
                    break;
                }

                return (
                  <TableRow
                    key={index}
                    style={{
                      color: color,
                      backgroundColor: backgroundColor,
                    }}
                  >
                    <TableCell align="center">
                      {row.destinationWarehouseName}
                    </TableCell>
                    <TableCell
                      component="th"
                      id={labelId}
                      scope="row"
                      align="center"
                    >
                      {row.id}
                    </TableCell>
                    <TableCell align="center">
                      <span>
                        {jMoment(row.shippingDate, 'YYYY/M/D')
                          .locale('fa')
                          .format('jYY/jMM/jDD')}
                      </span>
                    </TableCell>{' '}
                    <TableCell align="center">
                      <span>
                        {jMoment(row.deliveryDate, 'YYYY/M/D')
                          .locale('fa')
                          .format('jYY/jMM/jDD')}
                      </span>
                    </TableCell>
                    <TableCell align="center">
                      <span>
                        {jMoment(row.deliveryStartTime, 'hh:mm')
                          .locale('fa')
                          .format('HH:mm')}
                        {` - `}
                        {jMoment(row.deliveryEndTime, 'hh:mm')
                          .locale('fa')
                          .format('HH:mm')}
                      </span>
                    </TableCell>
                    {/* <TableCell align="center">{row.items.length}</TableCell> */}
                    <TableCell align="center">
                      <Can
                        perform="parcels-sender:changeStatus"
                        role={authContext.user.role}
                        yes={() => (
                          <FormControl style={{width: '100%'}}>
                            <Icon
                              path={mdiPencilOutline}
                              size={1}
                              className={classes.changStatusIcon}
                            />
                            <Select
                              className={classes.changStatusBox}
                              fullWidth
                              name={`status${index}`}
                              multiple
                              id={row.rubikaId}
                              value={[{}]}
                              IconComponent={() => null}
                              renderValue={() => (
                                <span className={classes.renderValue}>
                                  {translate(row.status, 'parcel')}
                                </span>
                              )}
                            >
                              <RadioGroup
                                className={classes.radioGroup}
                                aria-label={`status${index}`}
                                name={`status${index}`}
                                value={'item'}
                                onChange={(
                                  e: React.ChangeEvent<{value: unknown}>
                                ) =>
                                  props.changeStatus({
                                    id: row.id,
                                    body: `${e.target.value}`,
                                  })
                                }
                              >
                                {[
                                  'SUBMITTED',
                                  'SHIPPED',
                                  'DELIVERED',
                                  'CANCELLED',
                                ].map((item: any, index: number) => (
                                  <FormControlLabel
                                    className={classes.radioGroupItem}
                                    key={index}
                                    checked={row.status === item}
                                    value={item}
                                    control={<Radio />}
                                    label={translate(item, 'parcel')}
                                  />
                                ))}
                              </RadioGroup>
                            </Select>
                          </FormControl>
                        )}
                        no={() => (
                          <span>{translate(row.status, 'parcel')}</span>
                        )}
                      />
                    </TableCell>
                    <TableCell align="right">
                      <Link to={`/parcels/details/${row.id}`}>
                        <IconButton
                          aria-label="details"
                          size="small"
                          title="جزئیات محموله"
                          data-cy="details"
                        >
                          <Icon
                            path={mdiFileDocumentOutline}
                            size={1}
                            color={theme.palette.green.main}
                          />
                        </IconButton>
                      </Link>
                      {/* <Can
                        perform="/parcels-sender/:id/allLogs"
                        role={authContext.user.role}
                        yes={() => (
                          <Link to={`/parcels-sender/${row.id}/allLogs`}>
                            <IconButton
                              aria-label="details"
                              size="small"
                              title="تاریخچه محموله"
                              data-cy="details"
                            >
                              <Icon
                                path={mdiHistory}
                                size={1}
                                color={theme.palette.primary.main}
                              />
                            </IconButton>
                          </Link>
                        )}
                      /> */}
                      {row.status === 'CONFLICTED' && (
                        <Can
                          perform="/parcels-sender/:id/conflicts"
                          role={authContext.user.role}
                          yes={() => (
                            <Link to={`/parcels-sender/${row.id}/conflicts`}>
                              <IconButton
                                aria-label="cancel"
                                title="نمایش مغایرت"
                                size="small"
                              >
                                <Icon
                                  path={mdiArrowCollapseAll}
                                  size={1}
                                  color={theme.palette.orange.main}
                                />
                              </IconButton>
                            </Link>
                          )}
                        />
                      )}
                      <Can
                        perform="parcels-sender:editParcel"
                        role={authContext.user.role}
                        yes={() => (
                          <Link to={`/seller-parcels/${row.id}/edit`}>
                            <IconButton
                              title="ویرایش"
                              size="small"
                              onClick={() => handleOpen(row.id, 'edit')}
                            >
                              <Icon
                                path={mdiPencilOutline}
                                size={1}
                                color={theme.palette.blue.main}
                              />
                            </IconButton>
                          </Link>
                        )}
                      />
                      <Can
                        perform="parcels-sender:cancelParcel"
                        role={authContext.user.role}
                        yes={() => (
                          <IconButton
                            aria-label="cancel"
                            title="لغو محموله "
                            size="small"
                            onClick={() => handleOpenConfirmDisable(row.id)}
                          >
                            <Icon
                              path={mdiClose}
                              size={1}
                              color={theme.palette.error.main}
                            />
                          </IconButton>
                        )}
                      />
                    </TableCell>
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}
